/**
 * imageMapResizer
 */
export function image_map_resizer() {
  document.addEventListener( 'DOMContentLoaded', function() {
    imageMapResize();
  });
}
